(function($) {
  initAjaxCounters2();
})(jQuery);

/*
function initAjaxCounters() {
	$('.c-counter__minus:not(.initialised)').click(function () {
		var $input = $(this).parent().find('input');
		var count = parseInt($input.val()) - 1;
		count = count < 1 ? 1 : count;
		$input.val(count);
		$input.change();
		return false;
	}).addClass('initialised');

	$('.c-counter__plus:not(.initialised)').click(function () {
		var $input = $(this).parent().find('input');
		$input.val(parseInt($input.val()) + 1);
		$input.change();
		return false;
	}).addClass('initialised');
}
*/

function initAjaxCounters2() {
	$(document.body).on('click', '.c-counter__minus', function() {
		var $input = $(this).parent().find('input');
		var count = parseInt($input.val()) - 1;
		count = count < 1 ? 1 : count;
		$input.val(count);
		$input.change();
		return false;
	});

	$(document.body).on('click', '.c-counter__plus', function() {
		var $input = $(this).parent().find('input');
		$input.val(parseInt($input.val()) + 1);
		$input.change();
		return false;
	});

}
